define('features/overlayGameLauncher/adventureTwo/adventureTwoObservableData',[
    'knockout'
], function (ko) {

    return function () {

        var observableData = ko.observable({
            ADVENTURE_VERSION: 2
        });

        console.log('observableData', observableData);

        return observableData;
    };

});

